import { observer } from 'mobx-react';
import React from 'react';
import SGMSClient from '../../js/SGMSClient';
import { store } from '../../stores/store';


const TopCenterUI = () => {

  let time =  SGMSClient.sequenceManager.duration - SGMSClient.sequenceManager.currentTimeSecs

  let hours = Math.floor(time / 3600);
  // hours = hours < 10 ? "0" + hours : hours
  time = time - hours * 3600;
  let minutes = Math.floor(time / 60);
  minutes = minutes < 10 ? "0" + minutes : minutes
  let seconds = time - minutes * 60;
  seconds = seconds < 10 ? "0" + seconds : seconds

  return (
    <div className="top-center-ui">
      <div className="clock-title">{store.t("remaining_time")}</div>
      <div className="clock-content">
        {hours}:{minutes}:{seconds}
      </div>

    </div>
  );
};

export default observer(TopCenterUI)
